"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IHistorySettingModel", {
    enumerable: true,
    get: function() {
        return IHistorySettingModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const IHistorySettingModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    change_type: _zod.z.string(),
    created_at: _zod.z.date().optional(),
    ip_address: _zod.z.string().optional(),
    user: _zod.z.instanceof(_bson.ObjectId).optional(),
    setting_type: _zod.z.string()
});
